package com.essntl.features.dashboard.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.dashboard.ui.components.DashboardHeader
import com.essntl.features.dashboard.ui.components.DashboardItems
import com.essntl.features.dashboard.ui.components.DashboardTasks
import com.essntl.features.dashboard.ui.components.DashboardItineraries

@Composable
fun DashboardScreen(
    state: DashboardState,
    onNavigation: (DashboardNavigation) -> Unit,
    onEvent: (DashboardEvent) -> Unit,
    selectedId: String?,
) {
    Column(
        modifier = Modifier
            .verticalScroll(rememberScrollState())
            .fillMaxSize(),
    ) {
        DashboardHeader()

        DashboardItems(
            state = state,
            onNavigation = onNavigation,
            onEvent = onEvent,
            selectedId = selectedId,
        )

        DashboardItineraries(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
            selectedId = selectedId,
        )

        DashboardTasks(
            state = state,
            onNavigation = onNavigation,
            onEvent = onEvent,
            selectedId = selectedId,
        )
    }
}